import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sprout, ArrowRight, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";
import { Logo } from "../components/Logo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("info@elate.global");
  const [password, setPassword] = useState("growth2026");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      const seen = localStorage.getItem("growth_onboarded");
      navigate(seen ? "/app" : "/onboarding");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" style={{ background: "#F7F8F6" }}>
      {/* Left — form */}
      <div className="flex flex-col justify-center px-8 sm:px-16 lg:px-24 py-12">
        <div className="max-w-sm w-full mx-auto">
          <div className="mb-12">
            <Logo height={26} />
          </div>

          <p className="label-caps mb-3">Brand Intelligence</p>
          <h1 className="text-4xl font-extrabold tracking-tighter text-ink leading-tight">Welcome back.</h1>
          <p className="text-ink-2 mt-3 leading-relaxed">
            Measure your brand, understand your position, and know exactly what to do next.
          </p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <label className="label-caps">Email</label>
              <input
                type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email"
                className="mt-2 w-full rounded-md border bg-white px-3.5 py-2.5 text-sm text-ink focus-ring"
                style={{ borderColor: "#E7E8E4" }} required
              />
            </div>
            <div>
              <label className="label-caps">Password</label>
              <input
                type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="mt-2 w-full rounded-md border bg-white px-3.5 py-2.5 text-sm text-ink focus-ring"
                style={{ borderColor: "#E7E8E4" }} required
              />
            </div>
            {error && <p className="text-sm font-medium" style={{ color: "#D95C5C" }} data-testid="login-error">{error}</p>}
            <button type="submit" disabled={loading} className="btn-primary w-full focus-ring !py-3" data-testid="login-submit">
              {loading ? <Loader2 size={16} className="animate-spin" /> : <>Enter Growth <ArrowRight size={16} strokeWidth={2} /></>}
            </button>
          </form>

          <div className="mt-6 rounded-md border p-3 text-xs text-ink-2" style={{ borderColor: "#E7E8E4", background: "#fff" }}>
            <span className="font-semibold text-ink">Demo access</span> — pre-filled for Gilmours, Padstow.
          </div>
        </div>
      </div>

      {/* Right — editorial panel */}
      <div className="hidden lg:flex relative overflow-hidden items-end p-12" style={{ background: "#151515" }}>
        <img
          src="https://images.unsplash.com/photo-1614595737476-42487331b8a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          alt="Architecture" className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(21,21,21,.2) 0%, rgba(21,21,21,.85) 100%)" }} />
        <div className="relative text-white max-w-md">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em]" style={{ color: "#93C020" }}>NicheCom × Growth</p>
          <h2 className="text-3xl font-bold tracking-tight mt-3 leading-snug">
            NicheCom creates the content. Growth turns it into results.
          </h2>
          <p className="text-white/60 mt-4 leading-relaxed">
            The brand-performance operating system for estate agency branches.
          </p>
        </div>
      </div>
    </div>
  );
}
